import React, { useState, useRef } from 'react';
import TagInput from './TagInput';

export default function EditModal({ card, onSave, onClose }) {
  const [body, setBody] = useState(card.body);
  const [tags, setTags] = useState(card.tags ? card.tags.map(t => t.name) : []);
  const tagInputRef = useRef();
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleSave = async () => {
    if (!body.trim()) { setError('Card cannot be empty.'); return; }
    const finalTags = tagInputRef.current ? tagInputRef.current.flush() : tags;
    setSaving(true);
    try {
      const res = await fetch(`/api/cards/${card.id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ body: body.trim(), tags: finalTags }),
      });
      const updated = await res.json();
      onSave(updated);
    } catch {
      setError('Failed to save. Try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <h3>Edit Card</h3>
        <div className="form-group">
          <textarea
            className="form-textarea"
            value={body}
            onChange={e => setBody(e.target.value)}
            rows={6}
            autoFocus
          />
        </div>
        <div className="form-group">
          <label className="form-label">Tags</label>
          <TagInput ref={tagInputRef} value={tags} onChange={setTags} />
        </div>
        {error && <p style={{ color: 'var(--no)', fontFamily: 'sans-serif', fontSize: '0.9rem', marginBottom: '0.75rem' }}>{error}</p>}
        <div className="modal-actions">
          <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
            {saving ? 'Saving...' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
}
